// Red banner pinned above the Hero when the driver's geolocation is off.
// Collapsible: the summary line stays always visible; expanding reveals
// the iPhone / Android activation instructions plus a refresh reminder.

import React, { useState } from "react";
import styled from "styled-components";
import { tokens } from "./tokens";
import { Icon, ICON_PATHS } from "./icons";

const Banner = styled.div`
  background: ${tokens.colors.errorBg};
  color: ${tokens.colors.errorInk};
  border-bottom: 1px solid ${tokens.colors.dangerBorder};
`;

const Summary = styled.button`
  width: 100%;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  border: none;
  color: inherit;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
`;

const Title = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  font-weight: 600;
`;

const Body = styled.div`
  padding: 0 14px 12px;
  font-size: 12.5px;
  line-height: 1.5;
`;

const DeniedNote = styled.p`
  margin: 0 0 8px;
  color: ${tokens.colors.danger};
  font-weight: 600;
`;

const OsBlock = styled.details`
  margin-bottom: 6px;

  & > summary {
    font-weight: 600;
    cursor: pointer;
    list-style: none;
  }
  & > summary::-webkit-details-marker {
    display: none;
  }

  pre {
    margin: 4px 0;
    font-family: inherit;
    white-space: pre-wrap;
  }
`;

export default function GeoWarning({ show, locationApiError }) {
  const [expanded, setExpanded] = useState(false);
  if (!show) return null;

  return (
    <Banner>
      <Summary onClick={() => setExpanded((x) => !x)}>
        <Title>
          <Icon path={ICON_PATHS.alert} size={16} sw={2} />
          Géolocalisation désactivée — l'attente ne sera pas facturable
        </Title>
        <Icon
          path={expanded ? ICON_PATHS.chevronUp : ICON_PATHS.chevronDown}
          size={16}
          sw={2}
        />
      </Summary>
      {expanded && (
        <Body>
          {locationApiError === 1 && (
            <DeniedNote>
              Vous avez refusé l'accès du navigateur à votre position. Veuillez
              mettre à jour vos préférences dans les paramètres du navigateur.
            </DeniedNote>
          )}
          <div style={{ marginBottom: 4 }}>
            Pour activer la géolocalisation :
          </div>
          <OsBlock open>
            <summary>iPhone</summary>
            <pre>Réglages → Confidentialité → Service de localisation</pre>
            <div>
              Si besoin, autoriser votre navigateur dans la liste des
              applications sur le même écran de réglage.
            </div>
          </OsBlock>
          <OsBlock open>
            <summary>Android</summary>
            <pre>
              Paramètres → Sécurité et Confidentialité → Localiser mon appareil
            </pre>
          </OsBlock>
          <div style={{ marginTop: 6 }}>
            Après tout changement de réglages, actualisez la page.
          </div>
        </Body>
      )}
    </Banner>
  );
}
